/** 투자처 — 우리가 돈을 넣은 회사. 설계: `docs/02-design/000-data-model.md` */
export interface Company {
  id: number;
  name: string;
  bizNo: string | null;
  sector: string | null;
  foundedOn: string | null;
  homepage: string | null;
  status: CompanyStatus;
  note: string;
  createdAt: string;
  // 기업 기본정보 (VICS 1313) — DB v0.3. 모르면 null
  ceo?: string | null;
  corpNo?: string | null;
  address?: string | null;
  industryCode?: string | null;
  ventureCert?: boolean | null;
  /** 상장 여부 — 개인투자조합 상장사 10% 한도 (009) */
  listed?: boolean;
  fiscalMonth?: number | null;
  employees?: number | null;
  parValue?: number | null;
  products?: string;
  contactName?: string | null;
  contactTitle?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  /** normal 관리 · focus 집중 관리 · closed 종료 */
  mgmtLevel?: 'normal' | 'focus' | 'closed';
  managerEmployeeId?: number | null;
}

export const COMPANY_STATUSES = ['active', 'exited', 'writeoff'] as const;
export type CompanyStatus = (typeof COMPANY_STATUSES)[number];

export const COMPANY_STATUS_LABEL: Record<CompanyStatus, string> = {
  active: '보유 중',
  exited: '회수 완료',
  writeoff: '상각',
};

export const COMPANY_STATUS_STYLE: Record<CompanyStatus, string> = {
  active: 'bg-emerald-50 text-emerald-700',
  exited: 'bg-slate-100 text-slate-500',
  writeoff: 'bg-red-50 text-red-600',
};

export interface CompanyForm {
  name: string;
  bizNo: string;
  sector: string;
  foundedOn: string;
  homepage: string;
  note: string;
}
